import { render } from "./AdminAccommodationInquiriesView.vue?vue&type=template&id=5a6eef60&scoped=true&ts=true&lang=pug"
import script from "./AdminAccommodationInquiriesView.vue?vue&type=script&lang=ts"
export * from "./AdminAccommodationInquiriesView.vue?vue&type=script&lang=ts"

import "./AdminAccommodationInquiriesView.vue?vue&type=style&index=0&id=5a6eef60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6eef60"]])

export default __exports__